module.exports = __webpack_public_path__ + "img/BryanJ.042d6c47.png";